"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promisify = exports.waitJumpout = exports.sleep = void 0;
function sleep(time) {
    // tslint:disable-next-line:ter-prefer-arrow-callback
    return new Promise(function (resolve) {
        setTimeout(resolve, time);
    });
}
exports.sleep = sleep;
function waitJumpout() {
    return sleep(1000 * 5);
}
exports.waitJumpout = waitJumpout;
function promisify(o) {
    if (o && o.then && o.catch) {
        return o;
    }
    if (o instanceof Error) {
        return Promise.reject(o);
    }
    return Promise.resolve(o);
}
exports.promisify = promisify;
//# sourceMappingURL=utils.js.map